import React from "react";
import { Link } from "react-router-dom";
import { featuredSkill, skillGroups } from "../../data/skills";
import { nodeId, techNodes } from "../../data/connections";
import EvidenceCard from "../../components/investigation/EvidenceCard";
import EvidenceNode from "../../components/investigation/EvidenceNode";
import EvidencePin from "../../components/investigation/EvidencePin";
import { detailFromFeaturedSkill, detailFromSkillGroup } from "../../utils/evidenceDetail";

export const SkillsSection = () => (
  <div className="skills-cluster">
    <div className="evidence-group">
      <p className="evidence-group-label">Skill clusters</p>
      <div className="evidence-group-row skills-groups">
        {skillGroups.map((group, index) => (
          <EvidenceCard
            key={group.id}
            variant="paper"
            pin={index === 1 ? "brass" : "black"}
            rotate={index % 2 === 0 ? 0.8 : -0.7}
            className="skill-group-card"
            detail={detailFromSkillGroup(group)}
          >
            <p className="skill-index">
              {group.index} / {String(skillGroups.length).padStart(2, "0")}
            </p>
            <h3>{group.label}</h3>
            <ul className="skill-node-list">
              {group.items.map((item) => (
                <li key={item.id}>
                  <EvidenceNode label={item.label} variant="filled" size={7} />
                </li>
              ))}
            </ul>
          </EvidenceCard>
        ))}
      </div>
    </div>

    <div className="evidence-group">
      <p className="evidence-group-label">
        Recurring tools <span>· each red string ends at an exhibit</span>
      </p>
      <ul className="tech-tags">
        {techNodes.map((tech, index) => (
          <li
            key={tech.id}
            className="tech-tag"
            data-node={nodeId.tech(tech.id)}
            data-cursor="hover"
            tabIndex={0}
            style={{ "--card-rotate": `${index % 2 ? 1.6 : -1.4}deg` }}
          >
            <EvidencePin color="red" size="sm" className="tech-tag-pin" />
            <strong>{tech.label}</strong>
            <span>
              {tech.exhibits} {tech.exhibits === 1 ? "exhibit" : "exhibits"}
            </span>
          </li>
        ))}
      </ul>
    </div>

    <div className="evidence-group">
      <p className="evidence-group-label">Specialty on file</p>
      <EvidenceCard
        variant="manila"
        pin="brass"
        rotate={-1}
        className="skill-feature"
        detail={detailFromFeaturedSkill(featuredSkill)}
      >
        <span className="tag">{featuredSkill.badge}</span>
        <h3>{featuredSkill.label}</h3>
        <p>{featuredSkill.description}</p>
        <Link to={featuredSkill.link} className="exhibit-link">
          {featuredSkill.linkLabel} ↗
        </Link>
      </EvidenceCard>
    </div>
  </div>
);

export default SkillsSection;
